'use strict';

const moment = require('moment');
const StaticPath = '/static/';
const TimeFormat = 'YYYYMMDDHHmmss';

module.exports = function (env) {
    env.addGlobal('static', function (file) {
        return StaticPath + file;
    }, true);

    env.addFilter('tojson', function (obj) {
        return JSON.stringify(obj);
    });

    env.addFilter('replace_quotes', function (obj) {
        obj = obj.replace(/"/g, '\'');

        return obj;
    });

    env.addGlobal('version', function () {
        return moment()
            .format(TimeFormat);
    });

    return env;
};
